module.exports = __webpack_public_path__ + "static/frame-9c55070d72d4ae4838a909923d56276b.png";